import { FC } from "react";
import { pluralizeWithCount } from "@common/helpers/string";
import { buildScheduleLockedSuffix } from "@components/transactions/scheduleLock";
import { CommandsListProps } from "./lib";
import { TaskBulkOptionsCommandsList } from "./TaskBulkOptionsCommandsList";
import { useCommands } from "./useCommands";

export const TransactionBulkEntityCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const { returnToRoot } = useCommands();
    const {
        selectedTransactionCount = 0,
        transactionBulkEntityOptions = [],
        transactionsLockedByScheduleEntityCount = 0,
    } = options;

    return (
        <TaskBulkOptionsCommandsList
            heading={`Set entity for ${pluralizeWithCount("transaction", selectedTransactionCount)}${buildScheduleLockedSuffix(transactionsLockedByScheduleEntityCount)}`}
            options={transactionBulkEntityOptions}
            onOptionSelected={returnToRoot}
        />
    );
};
